import React , { Component } from 'react';
import {Link} from "react-router-dom";
import {Icon} from 'antd';

export default class LinkButton extends Component{
    render(){
        return(
            <div className={"normalButtonWrapper " + this.props.theme + "Btn"}>
                <Link className={"normalButton"} to={this.props.href}>
                    <div className="normalButtonInner">
                        <div>
                            <Icon type={this.props.icon}/>
                        </div>
                        <p>{this.props.text}</p>
                    </div>
                </Link>
            </div>
        )
    }
}